import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import { CustomerResponse } from '../../customer/models/customer-service.model';
import { Customer } from '../models/shared.model';

@Injectable()
export class CustomerSearchService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = `${this.env.API_BASE_URL}/service/customer-account-management/secure`;

  searchCustomers(searchtext: string): Observable<Customer[]> {
    return this.http.get<CustomerResponse>(`${this.baseUrl}/customers?query=${searchtext}`).pipe(
      map((response: CustomerResponse) => response.customers),
      catchError((error: HttpErrorResponse) => throwError(error.status)),
    );
  }
}
